<template>
	<span>
		<img src="@/assets/logo.png" class="img-logo" height="34" width="34" />
		<span class="ml-3 mr-5 text-subtitle-1 text-sm-h6">
			SIC&nbsp;
			<span class="font-weight-light">Cotação Admin</span>
		</span>
	</span>
</template>

<script>
export default {}
</script>

<style scoped>
.img-logo {
	vertical-align: middle;
}
</style>
